export default __webpack_public_path__ + "static/media/imagens.1776a4a3.jpg";